import React from 'react';

// 三阶段进度条：连接 ▸ 测试 ▸ 选择
const RacingProgress: React.FC<{ elapsedMs: number; phase?: string }> = ({ elapsedMs, phase }) => {
  const isCompleted = phase === 'completed';
  const isTesting = phase === 'testing';

  let progress: number;
  if (isCompleted) {
    progress = 100;
  } else if (isTesting) {
    progress = Math.min(70 + (elapsedMs / 1000) * 9, 98);
  } else {
    progress = Math.min((elapsedMs / 3000) * 70, 70);
  }

  const phaseLabel = isCompleted ? '完成' : isTesting ? '质量测试' : '连接中';

  return (
    <div className="space-y-1">
      <div className="flex justify-between text-[9px]">
        <span className="text-zinc-400">
          {phaseLabel} {isTesting && '(评估最佳线路)'}
        </span>
        <span className="font-mono text-zinc-300">{(elapsedMs / 1000).toFixed(1)}s</span>
      </div>
      <div className="h-1.5 w-full bg-white/5 rounded-full overflow-hidden relative">
        <div
          className={`h-full transition-all duration-300 ${
            isTesting || isCompleted
              ? 'bg-gradient-to-r from-blue-500 via-cyan-500 to-emerald-500'
              : 'bg-gradient-to-r from-blue-500 to-amber-500'
          }`}
          style={{ width: `${progress}%` }}
        />
      </div>
      <div className="flex justify-between text-[8px] text-zinc-600">
        <span className={!isTesting && !isCompleted ? 'text-blue-400' : ''}>连接</span>
        <span className={isTesting ? 'text-cyan-400' : ''}>测试</span>
        <span className={isCompleted ? 'text-emerald-400' : ''}>选择</span>
      </div>
    </div>
  );
};

export default RacingProgress;
